import styles from './styles.module.css';
import Loader from '../Form/Loader';

function ContainerLoader() {
  return (
    <div className={styles.adminLoadingWrapper}>
      <Loader size="large" />
    </div>
  );
}

export default ContainerLoader;
